import { Controller } from 'stimulus'
import Swiper from 'swiper'

export default class extends Controller {
  static targets = ['prev', 'next', 'bullets']

  connect() {
    const carousel = new Swiper(this.element, {
      containerModifierClass: '-',
      wrapperClass: 'HeroCarousel__items',
      slideClass: 'HeroCarousel__item',
      slideActiveClass: '-active',
      slideNextClass: '-next',
      slidePrevClass: '-prev',
      slidesPerView: 1,
      centeredSlides: true,
      speed: 400,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      pagination: {
        bulletActiveClass: '-active',
        bulletClass: 'HeroCarousel__bullet',
        bulletElement: 'button',
        clickable: true,
        currentClass: '-current',
        el: this.bulletsTarget,
        hiddenClass: '-hidden',
        lockClass: '-lock',
        modifierClass: '-',
        renderBullet: (_index, _className) => {
          return `<button type="button" class="${_className}"><span class="_VisuallyHidden">${_index + 1}ページ</span></button>`
        }
      },
      navigation: {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
      },
      breakpoints: {
        769: {
          slidesPerView: 'auto',
        },
      }
    })
  }
}